import React, { useState } from "react";
import Header from "../Layout/Header";
import { allapiAction } from "../../Redux/common/action";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import NewHeader from "../Layout/NewHeader";
import NewSidebar from "../Layout/NewSidebar";

function Deposit() {
  const copyAddress = () => {
    const text = "0x8168da3cCEB152C7b71eb04c11443a7733CdF37d";
    navigator.clipboard.writeText(text).then(() => {
      alert("Address copied!");
    });
  };

  const dispatch = useDispatch();
  // getprofile
  // addfund

  const [amount, setamount] = useState({});

  const hnedleToChange = (e) => {
    const { name, value } = e.target;
    setamount((prev) => ({
      ...prev,
      [name]: value,
    }));
    console.log(amount);
  };

  const hnedleToAddfund = async () => {
    if (!amount?.amount) {
      toast?.error("Please enter amount");
      return;
    } else if (amount?.amount < 10) {
      toast?.error("Please enter amount more than 10");
      return;
    } else if (!amount?.transaction_id) {
      toast?.error("Please enter transaction id");
      return;
    } else {
      const response = await dispatch(allapiAction.addfund(amount));
      if (response?.success) {
        dispatch(allapiAction.getprofile());
        setamount({ amount: "", transaction_id: "", transaction_details: "" });
        console.log("hendleToWithdrawal");
      }
    }
  };

  return (
    <div>
      <NewHeader />
      <NewSidebar />
      <div className="main">
      <div className="Deposite_new">
        <div className="container text-center">
          <h5 className="mb-3">Deposit</h5>
          <select className="form-select mb-3">
            <option selected>Deposit</option>
          </select>

          <label className="form-label">Amount</label>
          <input
            type="number"
            className="form-control mb-3"
            placeholder="Please enter amount"
            name="amount"
            onChange={hnedleToChange}
            value={amount?.amount}
          />

          <label className="form-label">Transaction id</label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Please enter transaction id"
            name="transaction_id"
            onChange={hnedleToChange}
            value={amount?.transaction_id}
          />

          {/* <label className="form-label">Transaction details</label>
          <input
            type="text"
            className="form-control mb-3"
            placeholder="Please enter transaction details"
            name="transaction_details"
            onChange={hnedleToChange}
            value={amount?.transaction_details}
          /> */}

          <button
            type="submit"
            className="btn btn-login mt-3"
            onClick={hnedleToAddfund}
          >
            Deposit Now
          </button>
          <button
            type="submit"
            className="btn btn-login mt-3"
            // onClick={hnedleToAddfund}
          >
            <Link to="/reacharge-list">Deposit History</Link>
          </button>

          <p className="fw-bold">Deposit </p>
          {/* <p className="text-muted">Minimum Deposit 10 USDT</p> */}
          <p className="text-danger small">
            *Deposit here will be sent to the above address .
          </p>
          

          <div className="qr-code">
            <img src="img/qr.png" alt="QR Code" />
          </div>

          {/* <button className="btn btn-outline-primary w-100">
            Save QR Code
          </button> */}

          <div className="mt-4 text-start">
            {/* <p className="text-muted small">
              This address supports USDT only. NFT is not supported.
            </p> */}
            <label className="fw-bold">Deposit Address</label>
            <div className="d-flex justify-content-between align-items-center border rounded p-2 address-box">
              <span id="walletAddress">
              0x8168da3cCEB152C7b71eb04c11443a7733CdF37d
              </span>
              <span className="copy-btn" onClick={copyAddress}>
                📋
              </span>
            </div>
            {/* <div className="info-box mt-2">
              <p className="fw-bold">Chain: BSC (BEP-20)</p>
            </div> */}
          </div>
        </div>
      </div>
      </div>
      <div style={{ height: "100px" }}></div>
    </div>
  );
}

export default Deposit;
